import PropTypes from 'prop-types';
import { BsCheckCircleFill, BsCircle, BsXCircleFill } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';

import ChannelBadge from '../../common/ChannelBadge/ChannelBadge';

function formatDueTime(iso) {
	if (!iso) return null;
	try {
		return new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' }).format(new Date(iso));
	} catch {
		return null;
	}
}

const TodoItem = ({ activity, companyId, onOpenCompany, onComplete, isPending }) => {
	const isCompleted = activity.status === 'completed' || isPending;
	const isFailed = activity.status === 'failed';
	const isClickable = Boolean(companyId);
	const dueLabel = formatDueTime(activity.dueAt);

	const handleBodyClick = () => {
		if (isClickable) onOpenCompany?.(companyId);
	};

	const handleCompleteClick = (e) => {
		e.stopPropagation();
		if (!isCompleted && !isFailed) onComplete?.(activity);
	};

	const handleDealClick = (e) => {
		e.stopPropagation();
		if (isClickable) onOpenCompany?.(companyId);
	};

	let StatusIcon;
	let iconClass;
	let iconLabel;
	if (isCompleted) {
		StatusIcon = BsCheckCircleFill;
		iconClass = 'text-success-500';
		iconLabel = 'Erledigt';
	} else if (isFailed) {
		StatusIcon = BsXCircleFill;
		iconClass = 'text-warning-500';
		iconLabel = 'Fehlgeschlagen';
	} else {
		StatusIcon = BsCircle;
		iconClass = 'text-bgBase-800 hover:text-primary-600';
		iconLabel = 'Als erledigt markieren';
	}

	return (
		<Card className="p-3 hover:border-primary-300 transition-colors">
			<div className="flex items-start gap-3">
				<button
					type="button"
					onClick={handleCompleteClick}
					disabled={isCompleted || isFailed}
					aria-label={iconLabel}
					title={iconLabel}
					className="flex-shrink-0 mt-0.5 disabled:cursor-not-allowed"
				>
					<StatusIcon className={`w-5 h-5 ${iconClass}`} />
				</button>

				<div onClick={handleBodyClick} className={`flex-1 min-w-0 ${isClickable ? 'cursor-pointer' : ''}`}>
					<p
						className={`text-sm font-medium ${
							isCompleted ? 'line-through text-bgBase-800' : isFailed ? 'text-bgBase-800' : 'text-text'
						}`}
					>
						{activity.title}
					</p>
					<div className="flex items-center gap-2 mt-1 flex-wrap">
						{activity.channelTypeId && <ChannelBadge channelTypeId={activity.channelTypeId} size="xs" />}
						{dueLabel && <span className="text-[11px] text-bgBase-800">{dueLabel}</span>}
					</div>
				</div>

				{isClickable && (
					<div className="flex-shrink-0">
						<Button variant="outline" size="sm" onClick={handleDealClick}>
							Zum Deal
						</Button>
					</div>
				)}
			</div>
		</Card>
	);
};

TodoItem.propTypes = {
	activity: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string,
		status: PropTypes.string,
		dueAt: PropTypes.string,
		channelTypeId: PropTypes.string,
		dealId: PropTypes.string,
	}).isRequired,
	companyId: PropTypes.string,
	onOpenCompany: PropTypes.func,
	onComplete: PropTypes.func,
	isPending: PropTypes.bool,
};

export default TodoItem;
